import React from "react";
import SecondaryButton from "./SecondaryButton";
import { Linkedin } from "lucide-react";
import { getLinkedinUrl } from "@/shared/utils/helperFunctions";
import { Tooltip } from "@heroui/react";

const LinkedinButton = ({ linkedinUrl }) => {
  const formattedUrl = getLinkedinUrl(linkedinUrl);

  return (
    <Tooltip
      content={linkedinUrl || "No LinkedIn URL"}
      placement="top"
      className="text-[10px] text-gray-500 rounded-md border-none max-w-xs break-all"
    >
      <div className="inline-block">
        <SecondaryButton
          title="Linked"
          endContent={<Linkedin size={10.5} className="text-secondary -ml-[5px]" />}
          onClick={() => {
            if (formattedUrl) window.open(formattedUrl, "_blank");
          }}
          className="text-secondary border-secondary shadow-none font-semibold font-sans"
        />
      </div>
    </Tooltip>
  );
};

export default LinkedinButton;
